import { IAuthInfo } from "src/app/angular-core/services/auth.service";
import { OperationEnum } from "../enums/operation.enums";
import { AllApiPermissions, ApiPermissions, IApiPermissions, IUserData } from "../interfaces/auth.interfaces";


export const hasRole = (role: string, authInfo: IAuthInfo): boolean => {
  if (!authInfo) {
    return false;
  }

  return authInfo.roles.includes(role);
}

export const hasRoleUserData = (role: string, userData: IUserData): boolean => {
  if (!userData) {
    return false;
  }

  return userData.roles.includes(role);
}

export const hasPermission = (permission: keyof AllApiPermissions, permissions: IApiPermissions, operation?: OperationEnum): boolean => {
  if (!permissions) {
    return false;
  }

  const permissionItem: string = (<string>permission).split('_').join('.');
  let hasPermission: boolean = false;

  for (const [key, value] of Object.entries(permissions)) {
    for (const [key2, value2] of Object.entries(value as ApiPermissions)) {
      if (key2 === permissionItem) {
        if (value2[operation || OperationEnum.READ]) {
          hasPermission = true;
          break;
        }
      }
    }
  }

  return hasPermission;
}

export const hasApiPermission = (permission: keyof AllApiPermissions, permissions: Partial<ApiPermissions>, operation?: OperationEnum): boolean => {
  if (!permissions) {
    return false;
  }

  const permissionItem: string = (<string>permission).split('_').join('.');
  let hasPermission: boolean = false;

  for (const [key, value] of Object.entries(permissions)) {
    if (key === permissionItem) {
      if ((<any>value)[operation || OperationEnum.READ]) {
        hasPermission = true;
        break;
      }
    }
  }

  return hasPermission;
}